export const sidebarWidthPx = 400;
export const appContainerPaddingDesktopPx = 15;
export const appContainerPaddingMobilePx = 9;
export const gapBetweenSidebarAndContentPx = 16;
